import Vue from "vue";

export const PageComponent = Vue.extend({
  //
});
